import React from 'react'
import { Box, Text } from 'theme-ui'
import moment from 'moment'
export default function EventDate({ date, variantName }) {
  return (
    <Box variant={`${variantName}.eventItemDateContainer`} className="eventItemDateContainer">
      <Text variant={`${variantName}.eventDate`} className="eventDate">
        {`${moment(date).format('DD')}`}
      </Text>
      <Text variant={`${variantName}.eventMonth`} className="eventMonth">
        {`${moment(date).format('MMM')}`}
      </Text>
    </Box>
  )
}
